import {ScalableResource} from "./scalableresource.model";
import {ReplicaSet} from "./replicaset.model";

export class ReplicationController extends ReplicaSet {

  defaultKind() {
    return 'ReplicationController';
  }
}

export class ReplicationControllers extends Array<ReplicationController>{
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
